<template>
<v-list dense three-line class='pa-0' >
  <v-progress-linear v-if='request.loading' indeterminate :height='2' >
  </v-progress-linear>
  <template v-for='comm in messages' >
    <communication-list-item
      :item='comm' :key='comm.id' >
    </communication-list-item>
    <v-divider :key='`div${comm.id}`'></v-divider>
  </template>
  <v-list-tile v-if='!request.loading && messages && messages.length === 0' >
    <v-list-tile-content>
      <v-list-tile-title>
        {{ $t('nomessages') }}
      </v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</v-list>
</template>
<script>
import CommunicationListItem from '@/components/listitems/CommunicationListItem'
export default {
  name: 'CommunicationList',
  components: {CommunicationListItem},
  props: {
    contextType: { type: String },
    params: { type: Object, default: () => { return {} } },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      page: 1,
      reqId: 'get-messages'
    }
  },
  mounted () {
    this.fetch()
  },
  watch: {
    paramsString () {
      this.fetch()
    },
    touch () {
      this.fetch()
    },
    loading () {
      this.$emit('loading', this.loading)
    }
  },
  computed: {
    paramsString () {
      return JSON.stringify(this.params)
    },
    request () {
      return this.$store.getters.getRequestById(this.reqId)
    },
    loading () {
      return this.$store.getters.getRequestById(this.reqId).loading
    },
    messages () {
      let messages = this.getObjectPath(this.request, 'result.data.results', [])
      if (messages && messages.length > 0) {
        this.$store.commit('addManyCommunications', messages)
      }
      return messages
    }
  },
  methods: {
    fetch () {
      this.$communicationguru
          .resource('communication')
          .id(this.reqId)
          .list(this.params)
    }
  },
  i18n: {
    messages: {
      en: {
        nomessages: 'No messages found'
      },
      es: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// CommunicationList.vue?3a59a9c8